import { Button, Avatar, Divider } from "@mui/material"
import { H6, Body2, Body3 } from "../../../../../themes/typography"

export default function TeamOverviewList({
    onManageTeam = () => { },
    totalStaffAdded = 0
}) {
    return (
        <div className="team-overview-list">

            <div className="team-overview-wrapper">

                <div className="team-overview-header">
                    <H6 fontWeight={600}>
                        Team
                    </H6>
                </div>

                <div className="team-overview-content">

                    <div className="team-member-item">
                        <Avatar sx={{ width: '38px', height: '38px' }}>
                            Y
                        </Avatar>
                        <div className="team-member-info">
                            <Body2 fontWeight={500}>
                                You
                            </Body2>

                            <Body3>
                                Owner
                            </Body3>
                        </div>
                    </div>

                    <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

                    {/* <div className="team-member-item">
                        <Avatar>A</Avatar>
                        <div className="team-member-info">
                            <Body2 fontWeight={500}>
                                Check In Staff
                            </Body2>

                            <Body3>
                                15 Staff Added
                            </Body3>
                        </div>
                    </div> */}

                    {/* <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} /> */}

                    <div className="team-member-item-with-btn">
                        <div className="team-member-item">
                            <Avatar sx={{ width: '38px', height: '38px' }}>
                                C
                            </Avatar>
                            <div className="team-member-info">
                                <Body2 fontWeight={500}>
                                    Check In Staff
                                </Body2>

                                <Body3>
                                    {totalStaffAdded > 0 ? `${totalStaffAdded} Staff Added` : 'No Staff Added'}
                                </Body3>
                            </div>
                        </div>
                        <Button variant="lightToggleActiveSm" onClick={onManageTeam}>
                            Manage Staff
                        </Button>
                    </div>

                </div>

                {/* <div className="team-overview-action-btn">
                    <Button variant="lightToggleActiveSm" fullWidth>
                        Manage Team
                    </Button>
                </div> */}

            </div>
        </div>
    )
}